import React, { createContext, useState } from "react";
import { calculateFamilyAndKidDiscountAmount, defaultMaxPeoplePerSlot } from "shared";


export const CartContext = createContext({
  items: [],
  getProductQuantity: () => { },
  addOneToCart: () => { },
  removeOneFromCart: () => { },
  deleteFromCart: () => { },
  getTotalCost: () => { },
  clearCart: () => { },
})
export function CartProvider({ children }) {
  const [cartProducts, setCartProducts] = useState([])

  function getProductQuantity(id) {
    const quantity = cartProducts.find(product => product.id === id)?.quantity;
    if (quantity === undefined) {
      return 0;
    }
    return quantity
  }

  function getProductDiscountAmount(id) {
    return cartProducts.find(product => product.id === id)?.discountAmount ?? 0;
  }

  function calculateCartRule(newCartProducts) {
    return newCartProducts.map((newCartProduct) => ({
      ...newCartProduct,
      discountAmount: calculateFamilyAndKidDiscountAmount(newCartProduct.title, newCartProducts) || 0
    }))
  }

  function addOneToCart(product) {
    const quantity = getProductQuantity(product.id);
    let newCartProducts = [...cartProducts];

    if (quantity === 0) {
      newCartProducts = newCartProducts.concat({
        id: product.id,
        title: product.title,
        quantity: 1,
        price: product.price,
      })
    } else {
      newCartProducts = newCartProducts.map(
        cartProduct => cartProduct.id === product.id
          ? { ...cartProduct, quantity: cartProduct.quantity + 1, }
          : {
            ...cartProduct,
          }
      )
    }
    
    if(newCartProducts[0]?.quantity > defaultMaxPeoplePerSlot) {
      return;
    }

    setCartProducts(
      [
        ...calculateCartRule(newCartProducts),
      ]
    )
  }

  function removeOneFromCart(id) {
    const quantity = getProductQuantity(id);

    if (quantity === 1) {
      deleteFromCart(id)
    } else {
      const newCartProducts = cartProducts.map(
          product =>
            product.id === id
              ? { ...product, quantity: product.quantity - 1 }
              : product
      )
      
      setCartProducts(
        [
          ...calculateCartRule(newCartProducts),
        ]
      )
    }
  }

  function deleteFromCart(id) {
    const newCartProducts =
      cartProducts.filter(currentProduct => {
        return currentProduct.id != id
      })

    setCartProducts(
      [
        ...calculateCartRule(newCartProducts),
      ]
    )
  }

  function getTotalCost(percent = 0, voucherAmountRemaining = 0) {
    let totalCost = 0;
    cartProducts.map((cartItem) => {
      totalCost += ((cartItem.price - (getProductDiscountAmount(cartItem.id))) * cartItem.quantity);
    })

    // Apply percent discount
    totalCost = totalCost - (percent / 100) * totalCost;

    // Apply voucher
    totalCost = totalCost - voucherAmountRemaining;
    if (totalCost < 0) totalCost = 0;

    return totalCost
  }

  function clearCart() {
    setCartProducts([]);
  }

  const contextValue = {
    items: cartProducts,
    getProductQuantity,
    getProductDiscountAmount,
    addOneToCart,
    removeOneFromCart,
    deleteFromCart,
    getTotalCost,
    clearCart,
  }

  return (
    <CartContext.Provider value={contextValue}>
      {children}
    </CartContext.Provider>
  )
}

export default CartProvider
